import React, { useState , useEffect} from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";

// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import MUIDataTable from "mui-datatables";
import moreIcon from "../../assets/tables/moreIcon.svg"; //
import Select from "react-select";
import DatePicker from 'react-datepicker';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import s from "../tables/Tables.module.scss";
import mock from "../tables/mock.js";
import { Projector } from "react-bootstrap-icons";
import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import BaseAPI from '../../api/apiurl.js';

const Project = function () {


  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [projectDropdown, setProjectDropdown] = useState([]); // project droupdown
  const [selectedValueproject, setSelectedValueproject] = useState(null);
  const [selectedValueStatus, setSelectedValueStatus] = useState(null);
  const [departmentDropdown, setDepartmentDropdown] = useState([]); 
  const [locationDropdown, setLocationDropdown] = useState([]); 
  const [selecteddepartment, setSelecteddepartment] = useState(null);
  const [selectedlocation, setSelectedlocation] = useState(null);




  const pageSize = 10;
const secondTablePagesCount = Math.ceil((data && data.length) ? data.length / pageSize : 0);

  const PaginationComponent = () => {
    const pagesToShow = 5;

    const startPage = Math.max(0, secondTableCurrentPage - Math.floor(pagesToShow / 2));
    const endPage = Math.min(secondTablePagesCount - 1, startPage + pagesToShow - 1);

    return (
      <Pagination className="pagination-with-border">
        <PaginationItem disabled={secondTableCurrentPage <= 0}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage - 1)}
            previous
            href="#top"
          />
        </PaginationItem>
        {[...Array(endPage - startPage + 1)].map((_, i) => (
          <PaginationItem
            key={i}
            active={startPage + i === secondTableCurrentPage}
          >
            <PaginationLink onClick={(e) => setSecondTablePage(e, startPage + i)} href="#top">
              {startPage + i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage + 1)}
            next
            href="#top"
          />
        </PaginationItem>
      </Pagination>
    );
  };






  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  } 

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } //

  const optionsStatus = [
    { value: '0', label: 'Planned' },
    { value: '1', label: 'In Progress' },
    { value: '2', label: 'Completed' }

]

  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const url = `${BaseAPI}projectview`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, company_id: companyId })
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((actualData) => {
        console.log(actualData);

        setData(actualData.data);
        console.log("response", data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  
  const fetchProject = async () => {
    try {
        const url = `${BaseAPI}project`;
        const companyId = localStorage.getItem('companyid');
        const customerId = localStorage.getItem('customerid');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // You might need to add other headers if required (e.g., authorization headers)
            },
            body: JSON.stringify({
                company_id: companyId,
                customer_id: customerId
            }),

        });

        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }

        const data = await response.json();
        setProjectDropdown(data.data.map(item => ({ label: item.entityname, value: item.id })));
    } catch (error) {
        console.error('Error:', error);
        // Handle the error here if needed
    }
};

const fetchDepartment = async () => {
  try {
      const url = `${BaseAPI}projectdepartment`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              // You might need to add other headers if required (e.g., authorization headers)
          },
          body: JSON.stringify({
              company_id: companyId,
              customer_id: customerId
          }),

      });

      if (!response.ok) {
          throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setDepartmentDropdown(data.data.map(item => ({ label: item.departName, value: item.departid })));
  } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
  }
};

const fetchLocation = async () => {
  try {
      const url = `${BaseAPI}projectlocation`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              // You might need to add other headers if required (e.g., authorization headers)
          },
          body: JSON.stringify({
              company_id: companyId,
              customer_id: customerId
          }),

      });

      if (!response.ok) {
          throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setLocationDropdown(data.data.map(item => ({ label: item.AssignDesc, value: item.assignid })));
  } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
  }
};

const handleSearch = () => {
  const customerId = localStorage.getItem('customerid');
  const companyId = localStorage.getItem('companyid');

  if (!customerId || !companyId) {
    console.log('Missing customer ID or company ID.');
    return;
  }

  // Check and set empty values to an empty string
  const selectedProjectLabel = selectedValueproject ? selectedValueproject.label || '' : '';
  const selectedDepartmentLabel = selecteddepartment ? selecteddepartment.label || '' : '';
  const selectedLocationLabel = selectedlocation ? selectedlocation.label || '' : '';
  const selectedStatusValue = selectedValueStatus ? selectedValueStatus.value || '' : '';

  const url = `${BaseAPI}projectfilters?company_id=${companyId}&customer_id=${customerId}&project=${selectedProjectLabel}&department=${selectedDepartmentLabel}&location=${selectedLocationLabel}&status=${selectedStatusValue}`;

  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.data && data.data.length > 0) {
        setData(data.data);
      } else {
        setData([]);
      }
    })
    .catch((error) => {
      console.error('Error fetching data from API:', error);
    });
};


const handleCancel = () => {
  fetchData();
  setSelectedValueproject(null);
  setSelecteddepartment(null);
  setSelectedlocation(null);
  setSelectedValueStatus(null);
};

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
      fetchData();
      fetchProject();
      fetchLocation();
      fetchDepartment();
      console.log("001", data);
    }, 2000);

    return () => clearTimeout(loadingTimeout);
  }, []);
  

console.log('001' , mock )
  return (
    <div>
    {isLoading ? (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
      </div>
    ) : (
    <div>
      
      <br/>
       <Row >
              <Col>
                <Row className="mb-4">
                  <Col>
                    <Widget>
                      <div style={{ padding: "20px" }}>
                        <div className="headline-2" style={{color : "blue"}}>Project Search
                          <div style={{ float: "right" }}>
                        
                            <button type="button" className="btn btn-primary"  onClick={handleSearch}>
                              <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                              Search
                            </button> &nbsp;
                            <button type="button" className="btn btn-primary" onClick={handleCancel} >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ whiteSpace: 'nowrap' }}>
                        <div className="col-sm-3">
                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Project</label>
                          <div className="row-sm-3" style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                                        // isMulti
                                        className="select2-selection"
                                        placeholder="Choose..."
                                        options={projectDropdown}
                                        value={selectedValueproject}
                                        onChange={setSelectedValueproject}
                                    />
                          </div>
                        </div>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Department</label>
                          <div className="row-sm-3" style={{ padding: "10px" }}>
                          <Select
                              classNamePrefix="select2-selection"
                              placeholder="Choose..."
                              title="Asset Form"
                              options={departmentDropdown}
                              value={selecteddepartment}
                              onChange={setSelecteddepartment}
                            />
                          </div>
                        </div>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Location</label>
                          <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                          <Select
                              classNamePrefix="select2-selection"
                              placeholder="Choose..."
                              title="Asset Form"
                              options={locationDropdown}
                              value={selectedlocation}
                              onChange={setSelectedlocation}
                            />
                          </div>

                        </div>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Status</label>
                          <div className="row-sm-2" style={{ marginRight: '5px', padding: "10px" }}>
                          <Select
                              classNamePrefix="select2-selection"
                              placeholder="Choose..."
                              title="Asset Form"
                              options={optionsStatus}
                              value={selectedValueStatus}
                              onChange={setSelectedValueStatus}
                            />
                          </div>

                        </div>
                      </div>



                    </Widget>
                  </Col>
                </Row>
              </Col>
            </Row>
      <Row>
        <Col>
          <Row className="mb-4">
            <Col>
            <Widget>
                    <div  style={{padding: "20px"}}>
                       <div className="headline-2" style={{color : "blue"}}>Project Details</div>
                      {/* <Dropdown
                        className="d-none d-sm-block"
                        nav
                        isOpen={tableDropdownOpen}
                        toggle={() => tableMenuOpen()}
                      >
                        <DropdownToggle nav>
                          <img className="d-none d-sm-block" src={moreIcon} alt="More..." />
                        </DropdownToggle>
                        <DropdownMenu >
                          <DropdownItem>
                            <div>Copy</div>
                          </DropdownItem>
                          <DropdownItem>
                            <div>Edit</div>
                          </DropdownItem>
                          <DropdownItem>
                            <div>Delete</div>
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown> */}
                    </div>
                    <div className="widget-table-overflow">
                      <Table className="table-striped table-borderless table-hover" responsive >
                        <thead>
                          <tr style={{ whiteSpace: 'nowrap' }}>
                            {/* <th>Customer</th> */}
                            <th>Project Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Location</th>
                            <th>Department</th>
                            <th>Users(s)</th>
                            <th>Tasks</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
  {data && data.length > 0 ? (
    data
      .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
      .map((item, index) => (
        <tr key={index}>
          {/* <td>{item.entitydesc}</td> */}
          <td>{item.entityname}</td>
          <td>{item.startdate}</td>
          <td>{item.enddate}</td>
          <td>{item.AssignDesc}</td>
          <td>{item.departName}</td>
          <td>{item.staffestimated}</td>
          <td>{item.totaltasks}</td>
          <td>
            <Badge
              style={{
                backgroundColor:
                  item.status === 'Planned' ? 'blue' :
                  item.status === 'Completed' ? 'Green' :
                  item.status === 'In Progress' ? 'indigo' :
                  item.status === 'Cancelled' ? 'gray' : 'black',
                color: item.status === '' ? 'black' : 'white',
              }}
            >
              {item.status}
            </Badge>
          </td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", color: "red" }}>
        No Data Avilable
      </td>
    </tr>
  )}
</tbody>

                      </Table>
                      <div style={{ textAlign: "left", marginTop: "20px" }}>
                          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                            Total project: <span style={{ color: "blue" }}>{data ? data.length : 0}</span>
                          </p>
                        </div>
                      <PaginationComponent />
                    </div>
                  </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
    	)}
      </div>
  )
}

const spinnerStyle = css`
display: block;
margin: 0 auto;
`;

export default Project;
